<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndat"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndat'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntim"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntim'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S123G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_60 col_17'><dynamic-field [id]='"scrnnm"' [size]=60 [line]=2 [column]=17 [(ngModel)]='scrnnm'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_10 col_11'><span class='brt high default' id='text3'>PNR CREATE</span>  </div>
  <div class='lgr_20 col_46'><span class='brt high default' id='text4'>INITIAL      INITIAL</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_14 col_04'><span class='brt high default' id='text5'>PNR #     DATE</span>  </div>
  <div class='lgr_14 col_24'><span class='brt high default' id='text6'>PASSENGER NAME</span>  </div>
  <div class='lgr_22 col_46'><span class='brt high default' id='text7'>ORG/DST    TRAVEL DATE</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel1"' [size]=1 [line]=6 [column]=1 [(ngModel)]='sel1'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld1"' [size]=77 [line]=6 [column]=3 [(ngModel)]='fld1'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel2"' [size]=1 [line]=7 [column]=1 [(ngModel)]='sel2'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld2"' [size]=77 [line]=7 [column]=3 [(ngModel)]='fld2'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel3"' [size]=1 [line]=8 [column]=1 [(ngModel)]='sel3'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld3"' [size]=77 [line]=8 [column]=3 [(ngModel)]='fld3'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel4"' [size]=1 [line]=9 [column]=1 [(ngModel)]='sel4'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld4"' [size]=77 [line]=9 [column]=3 [(ngModel)]='fld4'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel5"' [size]=1 [line]=10 [column]=1 [(ngModel)]='sel5'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld5"' [size]=77 [line]=10 [column]=3 [(ngModel)]='fld5'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel6"' [size]=1 [line]=11 [column]=1 [(ngModel)]='sel6'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld6"' [size]=77 [line]=11 [column]=3 [(ngModel)]='fld6'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel7"' [size]=1 [line]=12 [column]=1 [(ngModel)]='sel7'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld7"' [size]=77 [line]=12 [column]=3 [(ngModel)]='fld7'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel8"' [size]=1 [line]=13 [column]=1 [(ngModel)]='sel8'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld8"' [size]=77 [line]=13 [column]=3 [(ngModel)]='fld8'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel9"' [size]=1 [line]=14 [column]=1 [(ngModel)]='sel9'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld9"' [size]=77 [line]=14 [column]=3 [(ngModel)]='fld9'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel10"' [size]=1 [line]=15 [column]=1 [(ngModel)]='sel10'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld10"' [size]=77 [line]=15 [column]=3 [(ngModel)]='fld10'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel11"' [size]=1 [line]=16 [column]=1 [(ngModel)]='sel11'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld11"' [size]=77 [line]=16 [column]=3 [(ngModel)]='fld11'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel12"' [size]=1 [line]=17 [column]=1 [(ngModel)]='sel12'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld12"' [size]=77 [line]=17 [column]=3 [(ngModel)]='fld12'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel13"' [size]=1 [line]=18 [column]=1 [(ngModel)]='sel13'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld13"' [size]=77 [line]=18 [column]=3 [(ngModel)]='fld13'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel14"' [size]=1 [line]=19 [column]=1 [(ngModel)]='sel14'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld14"' [size]=77 [line]=19 [column]=3 [(ngModel)]='fld14'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_01 col_01'><dynamic-field [id]='"sel15"' [size]=1 [line]=20 [column]=1 [(ngModel)]='sel15'></dynamic-field></div>
  <div class='lgr_77 col_03'><dynamic-field [id]='"fld15"' [size]=77 [line]=20 [column]=3 [(ngModel)]='fld15'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text8'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text9'>4-EXIT</span>  </div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text10'>3-MAIN</span>  </div>
  <div class='lgr_12 col_46'><span class='brt high default' id='text11'>11-PRINT ALL</span>  </div>
  <div class='lgr_18 col_61'><span class='brt high default' id='text12'>12-PRINT SELECTION</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text13'>SHIFT PF:</span>  </div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
</div>
</div>
